module.exports = __webpack_public_path__ + "static/headshot-steffan-haas-2x.4971f0e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-steffan-haas-2x.jpg
// module id = 537
// module chunks = 152909308826437